"use client"

import { useState } from "react"
import "./FintechFaq.css"

const faqData = [
  {
    question: "What is Fintech?",
    answer:
      "FinTech, short for financial technology, refers to the integration of technology into offerings by financial services companies to improve their use and delivery to consumers. It primarily works by unbundling services offered by traditional financial institutions and creating new markets for these services.",
  },
  {
    question: "How does financial technologies benefits scale-up and enterprises?",
    answer:
      "Financial technology offers numerous benefits, including enhanced efficiency, improved customer experience, lower costs, and the ability to analyze large data sets for better decision-making. It enables scale-ups and enterprises to streamline financial operations and adapt to the rapidly changing digital economic landscape.",
  },
  {
    question: "What is technological financing and how does it relate to fintech?",
    answer:
      "Technology financing is a subset of FinTech that provides funding for technological innovations and enterprises. It is crucial in supporting scale-ups and established companies in their quest to adopt new technologies and stay competitive.",
  },
  {
    question:
      "How does technology finance impact the financial sector?",
    answer:
      "Technology finance revolutionizes the financial sector by introducing new financial products and services that are more efficient, secure, and user-friendly. It allows for more flexible financing options for businesses, aiding their growth and development.",
  },
  {
    question: "What role does technology play in finance?",
    answer:
      "Technology in finance has transformed the way financial transactions are conducted. It includes advancements like blockchain, AI, machine learning, and big data analytics, significantly increasing financial services' speed, security, and efficiency.",
  },
  {
    question: "What are financial technology and how are they changing industry?",
    answer:
      "Financial technologies are tools and platforms that use technology to enhance or automate financial services and processes. They are changing the industry by introducing mobile banking, peer-to-peer lending, and algorithmic trading innovations.",
  },
  {
    question:
      "How is finance technology evolving in the way business operate?",
    answer:
      "Finance technology is evolving business operations by automating and optimizing financial processes, reducing errors, and providing real-time financial insights. This evolution allows businesses to focus on strategic growth and less on manual financial management.",
  },
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section9977">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT</h1>
          <h2 className="sub-title">FINTECH TECHNOLOGY SOLUTIONS</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
